import { call, take, put } from 'redux-saga/effects';
import { get, post, putMethod, patchMethod, deleteMethod } from '../../utils/api';
import settings from '../../utils/settings';
import {
  CATEGORY_REQUEST,
  CATEGORY_SUCCESS,
  CREATE_CATEGORY_REQUEST,
  UPDATE_SKU_REQUEST,
  DEFAULT_SUCCESS,
  DELETE_SKU_REQUEST,
  DELETE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_REQUEST,
  SKU_LIST_REQUEST,
  SKU_LIST_SUCCESS,
  REQUEST_FAILURE,
  addCategorySuccess,
  updateCategoryTypeSuccess,
  deleteCategorySuccess,
  addSKUSuccess,
  updateSKUSuccess,
  deleteSKUSuccess
} from './constants';

export function* getCategoryList() {
  while (true) {
    yield take(CATEGORY_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.digiCoreUrl(`platform/discount/categories`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        if (result !== []) {
          yield put({ type: CATEGORY_SUCCESS, categoryList: response.result });
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.reason });
        }
      }
    } catch (error) {
      console.log('Saga: getCategoryList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* createCategory() {
  while (true) {
    const request = yield take(CREATE_CATEGORY_REQUEST);
    try {
      let response;
      const { successCbk, ...requestParams } = request.payload;
      response = yield call(post, {
        url: settings.digiCoreUrl(`platform/discount/category`),
        body: requestParams,
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({ type: DEFAULT_SUCCESS, message: addCategorySuccess, messageType: 'success' });
          successCbk(result);
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.reason });
        }
      }
    } catch (error) {
      console.log('Saga: createCategory:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* updateSKU() {
  while (true) {
    const request = yield take(UPDATE_SKU_REQUEST);
    try {
      let response;
      const { categoryName, skuNumber, discount, isFrom, successCbk = () => {} } = request.payload;
      const method = isFrom === 'editSKU' ? patchMethod : putMethod;
      response = yield call(method, {
        url: settings.digiCoreUrl(
          `platform/discount/category/${categoryName}/sku?sku_number=${skuNumber}&discount=${discount}`
        ),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          if (isFrom === 'editSKU') {
            yield put({ type: DEFAULT_SUCCESS, message: updateSKUSuccess, messageType: 'success' });
          } else {
            yield put({ type: DEFAULT_SUCCESS, message: addSKUSuccess, messageType: 'success' });
          }
          successCbk(result);
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.reason });
        }
      }
    } catch (error) {
      console.log('Saga: updateSKU:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* deleteSKU() {
  while (true) {
    const request = yield take(DELETE_SKU_REQUEST);
    try {
      let response;
      const { categoryName, skuNumber, successCbk = () => {} } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.digiCoreUrl(`platform/discount/category/${categoryName}/sku?sku_number=${skuNumber}`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({ type: DEFAULT_SUCCESS, message: deleteSKUSuccess, messageType: 'success' });
          successCbk(result);
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.reason });
        }
      }
    } catch (error) {
      console.log('Saga: deleteSKU:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* deleteCategory() {
  while (true) {
    const request = yield take(DELETE_CATEGORY_REQUEST);
    try {
      let response;
      const { categoryName, successCbk = () => {} } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.digiCoreUrl(`platform/discount/category?category_name=${categoryName}`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: DEFAULT_SUCCESS,
            message: result.reason || deleteCategorySuccess,
            messageType: 'success'
          });
          successCbk();
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.reason });
        }
      }
    } catch (error) {
      console.log('Saga: deleteCategory:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* updateCategoryType() {
  while (true) {
    const request = yield take(UPDATE_CATEGORY_REQUEST);
    try {
      let response;
      const { categoryName, categoryType, successCbk = () => {} } = request.payload;
      response = yield call(patchMethod, {
        url: settings.digiCoreUrl(`platform/discount/category/${categoryName}?category_type=${categoryType}`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({ type: DEFAULT_SUCCESS, message: updateCategoryTypeSuccess, messageType: 'success' });
          successCbk(result);
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.reason });
        }
      }
    } catch (error) {
      console.log('Saga: updateCategoryType:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getSKUList() {
  while (true) {
    yield take(SKU_LIST_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.digiCoreUrl(`platform/discount/category/sku`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        if (result !== []) {
          yield put({ type: SKU_LIST_SUCCESS, skuList: response.result });
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.reason });
        }
      }
    } catch (error) {
      console.log('Saga: getSKUList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}
